<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-alert color="gifty" text border="top" v-if="can('admin')">
          <div class="d-flex align-center justify-space-between">
            <div>
              Veuillez choisir une campagne pour visualiser les données filtrées.
            </div>
            <div :style="{width: '400px'}">
              <v-autocomplete placeholder="Sélectionner une campagne..."
                              :loading="isLoading"
                              :items="campaigns"
                              color="gifty"
                              v-model="boosting_method_id"
                              item-value="id"
                              hide-details
                              item-text="name"></v-autocomplete>
            </div>
          </div>
        </v-alert>
        <div v-if="boosting_method_id">
          <div class="text-end mb-3">
            <v-btn color="gifty" dark depressed @click="refresh">
              <v-icon left>mdi-refresh</v-icon>
              Mettre à jour
            </v-btn>
          </div>
          <WidgetCards ref="ref1" :boosting_method_id="boosting_method_id"/>
          <AttemptsWilayas ref="ref5" :boosting_method_id="boosting_method_id"/>
          <AttemptsGraph ref="ref6" :boosting_method_id="boosting_method_id"/>
          <TopWilayas ref="ref2" :boosting_method_id="boosting_method_id"/>
          <UsagesTable ref="ref3" :boosting_method_id="boosting_method_id"/>
          <DailyUsages ref="ref4" :boosting_method_id="boosting_method_id"/>
          <Distributeurs v-if="boosting_method_id === 4" ref="ref7" :boosting_method_id="boosting_method_id"/>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import UsagesTable from "@/views/admin-boostings/dashboard/components/UsagesTable";
import WidgetCards from "@/views/admin-boostings/dashboard/components/WidgetCards";
import TopWilayas from "@/views/admin-boostings/dashboard/components/TopWilayas";
import AttemptsWilayas from "@/views/admin-boostings/dashboard/components/AttemptsWilayas";
import DailyUsages from "@/views/admin-boostings/dashboard/components/DailyUsages";
import {HTTP} from "@/http-common";
import AttemptsGraph from "@/views/admin-boostings/dashboard/components/AttemptsGraph";
import Distributeurs from "@/views/admin-boostings/dashboard/components/Distributeurs";

export default {
  components: {AttemptsGraph, TopWilayas, UsagesTable, WidgetCards, DailyUsages, AttemptsWilayas, Distributeurs},
  data() {
    return {
      campaigns: [],
      boosting_method_id: null,
      isLoading: false
    }
  },
  methods: {
    refresh() {
      this.$refs.ref1.getWidgets()
      this.$refs.ref2.getTopWilayas()
      this.$refs.ref3.getUsages()
      this.$refs.ref4.getDailyUsage()
      this.$refs.ref5.getAttemptsWilayas()
      this.$refs.ref6.getAttemptsGraph()
      this.$refs.ref7.getDistributeurs()
    },
    fetchCampaigns() {
      this.isLoading = true
      HTTP.get('/v1/boosting-methods').then(res => {
        this.campaigns = res.data.data
        this.boosting_method_id = this.campaigns && this.campaigns.length ? this.campaigns[0].id : null
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    if (this.can('client')) {
      if (this.$store.state.user.user.id === 55402) {
        this.boosting_method_id = 2
      }
      if (this.$store.state.user.user.id === 57748) {
        this.boosting_method_id = 4
      }
      if (this.$store.state.user.user.id === 48596) {
        this.boosting_method_id = 1
      }
    } else {
      this.fetchCampaigns()
    }
  },
};
</script>

<style scoped>
</style>
